import { IDealProperty } from '@/Api/Deal';
import AddressVersionEnum from '@/Api/Deal/AddressVersionEnum';
import propertyStreetTypeLabels from '@/Api/Deal/propertyStreetTypeLabels';

function getStreetAddress(property: IDealProperty): string {
    switch (property.addressVersion) {
        case AddressVersionEnum.V2: {
            let streetAddress: string = '';

            if (property.unitNumber && property.unitNumber.length > 0) {
                streetAddress += property.unitNumber + '/';
            }

            const streetTypeHumanReadable: string = propertyStreetTypeLabels[property.streetType];

            streetAddress += `${property.streetNumber || '-'} ${property.streetName || '-'} ${streetTypeHumanReadable || '-'}`;

            return streetAddress;
        }
        case AddressVersionEnum.GNAF_V1:
        default:
            return property.streetAddress;
    }
}

export function getFormattedAddress(property: IDealProperty): string {
    return `${getStreetAddress(property) || '-'}, ${property.suburb || '-'} ${property.state || '-'} ${property.postcode || '-'}`;
}